import React from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '../ui/card';
import TiltCard from '../TiltCard';
import ScrollReveal from '../ScrollReveal';

const ValuesSection = ({ values, iconMap, heading, columns = 2 }) => {
  const colClass = columns === 1 ? 'md:grid-cols-1' : columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2';
  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {heading || 'Our Values'}
            </h2>
            <div className="w-24 h-1 bg-red-600 mx-auto"></div>
          </div>
        </ScrollReveal>

        <div className={`grid grid-cols-1 ${colClass} gap-8 max-w-5xl mx-auto`}>
          {values.map((value, index) => {
            const Icon = iconMap[value.icon];
            return (
              <ScrollReveal key={value.id} delay={index * 100}>
                <TiltCard>
                  <Card className="bg-slate-800 border-slate-700 h-full hover:border-gray-400/50 transition-all duration-300">
                    <CardHeader>
                      <div className="flex items-start space-x-4">
                        <div className="flex-shrink-0">
                          <div className="w-14 h-14 bg-red-600/10 rounded-lg flex items-center justify-center">
                            <Icon className="w-7 h-7 text-red-500" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <CardTitle className="text-white text-xl mb-3">
                            {value.title}
                          </CardTitle>
                          <CardDescription className="text-gray-300 leading-relaxed">
                            {value.description}
                          </CardDescription>
                        </div>
                      </div>
                    </CardHeader>
                  </Card>
                </TiltCard>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
